import { createSelector } from "reselect";

export const isPanelOpen = state => !!state.ui.library.panel.type;
export const getPanel = state => state.ui.library.panel;
export const getBookGridInfo = state => state.ui.library.gridview;
export const isMobileMenuOpen = state => state.ui.library.mobileMenu;

